class ProfileModel {
    constructor({
        username = '',
        password = '',
        profilePicture = '',
        firstName = '',
        lastName = '',
        files = [],
        user_id = '',
        key = '', // TODO: remove only used for Feed, but necessary to set key prop in Feed
        email = '',
     }) {
        this.username = username;
        this.password = password;
        this.profilePicture = profilePicture;
        this.firstName = firstName;
        this.lastName = lastName;
        this.files = files;
        this.user_id = user_id;
        this.key = key;
        this.email = email;
    }
}

export default ProfileModel;